let timeoutTrackSearch: any;

export const trackSearch = (searchText: string) => {
    clearTimeout(timeoutTrackSearch);
    var dataLayer = (window as { [key: string]: any })["dataLayer"];
    timeoutTrackSearch = setTimeout(() => {
        dataLayer.push({
            event: "ga4_cheatsheet_search",
            search_string: searchText
        });        
    }, 1000);
}
